import { useEffect, useState } from 'react'
import Lottie from 'lottie-react'
import { RenderIf } from 'components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { loadAnimation } from 'featureSliced/shared/utils/loadAnimation'
import { AnimationData } from 'featureSliced/shared/utils/animations'
import { AppGuideContainer } from './styled'

export const AppGuide = () => {
  const appTheme = useMySelector((state) => state.app.interfaceStyles.appTheme)
  const [guideAnimation, setGuideAnimation] = useState<AnimationData | null>(
    null
  )

  useEffect(() => {
    loadAnimation(`${appTheme}/guide.json`, (error) => {
      console.error('Failed to load guide animation:', error)
    }).then(setGuideAnimation)
  }, [])

  return (
    <RenderIf condition={!!guideAnimation}>
      <AppGuideContainer>
        <Lottie animationData={guideAnimation} loop={true} />
      </AppGuideContainer>
    </RenderIf>
  )
}
